// Accordions (PDP rows, FAQ rows) open and close with a short slide instead of jumping open.
(() => {
  if (window.vanliferDetailsSlide) return;
  window.vanliferDetailsSlide = true;

  const SELECTOR = '.product__accordion details, details.faq-item';
  const DURATION = 300;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const closedHeight = (details) =>
    details.querySelector('summary').offsetHeight + (details.offsetHeight - details.clientHeight);

  const slide = (details, from, to, done) => {
    details.dataset.sliding = 'true';
    details.style.overflow = 'hidden';
    const animation = details.animate({ height: [`${from}px`, `${to}px`] }, { duration: DURATION, easing: 'ease-out' });
    animation.onfinish = animation.oncancel = () => {
      if (done) done();
      details.style.overflow = '';
      delete details.dataset.sliding;
    };
  };

  const groupOf = (details) => {
    const name = details.getAttribute('name');
    if (name) {
      details.dataset.group = name;
      details.removeAttribute('name');
    }
    return details.dataset.group;
  };

  const close = (details) => slide(details, details.offsetHeight, closedHeight(details), () => { details.open = false; });

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    const details = summary && summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SELECTOR) || reducedMotion.matches) return;
    event.preventDefault();
    if (details.dataset.sliding) return;

    if (details.open) {
      close(details);
      return;
    }

    // Exclusive accordions (name="..."): the group is handled here so the open sibling slides closed. The native name
    // attribute is moved to data-group, otherwise the browser snaps rows shut when two clicks overlap.
    const group = groupOf(details);
    if (group) {
      document.querySelectorAll(`details[data-group="${group}"], details[name="${group}"]`).forEach((other) => {
        if (other === details || !other.open) return;
        groupOf(other);
        other.getAnimations().forEach((animation) => animation.cancel());
        close(other);
      });
    }
    const from = details.offsetHeight;
    details.open = true;
    slide(details, from, details.offsetHeight);
  });
})();
